"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function view(props) {
    return {
        state: {},
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {}
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// ../player-career-site-header-footer/controls/PageHeader/View.js
// module id = 558
// module chunks = 0